import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F115 {
  f115_01: string;        // 包裝代號 (PK, max 2 chars)
  f115_02: number;        // 未知欄位
  f115_11: string;        // 包裝說明 (max 150 chars)
  f115_11a: string;       // 包裝說明備注
  f115_12: boolean;       // 舊代號標記
  f115_91: string;        // 建檔人
  f115_92: string | null; // 建檔日期
  f115_93: string;        // 修改人
}

export interface CreateRequest {
  f115_01: string; // 包裝代號
  f115_11: string; // 包裝說明
}

export interface UpdateRequest {
  f115_11: string;  // 包裝說明
  f115_12?: boolean; // 舊代號標記 (optional)
}

export interface ListResponse {
  data: F115[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw1115f1Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pw1115f1', { params });
    return res.data;
  },

  async get(code: string): Promise<F115> {
    const res = await apiClient.get(`/api/pw1115f1/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F115> {
    const res = await apiClient.post('/api/pw1115f1', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F115> {
    const res = await apiClient.put(`/api/pw1115f1/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/pw1115f1/${encodeURIComponent(code)}`);
  },
};
